/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/Notes/Note/DeleteAction/Content/Content/DeleteAction",
  isSubmitting
  
}) {
let leadIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'lead',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={onClick}
 type="critical"
 data="lead"
 disabled={leadIsSubmittingData}
 text="Delete note"
/>
{children}
</React.Fragment>)
}